<template>
    <div style="">
        <el-form label-width="120px" :model="editData">
          <el-form-item v-if="null!=editData.approvalOption&&-1==editData.approvalStatus" label="审批不通过原因:" prop="approvalOption">
            <el-input type="textarea" v-model="editData.approvalOption" :disabled="true" placeholder="（空）"></el-input>
          </el-form-item>
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="editData.name" :disabled="true" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="sex">
            <el-select v-model="editData.sex" :disabled="true" placeholder="请选择性别" width="100%" style="width:100%;">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号:" prop="idCardNo">
            <el-input v-model="editData.idCardNo" :disabled="true" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input v-model="editData.phone" :disabled="true" placeholder="请输入手机号" type="number"></el-input>
          </el-form-item>
          <el-form-item label="家庭住址:">
            <el-input v-model="editData.address" :disabled="true" placeholder="请输入家庭住址"></el-input>
          </el-form-item>
          <el-form-item label="影响等级:" prop="levelId">
            <el-select v-model="editData.levelId" :disabled="true" placeholder="请选择影响等级" width="100%" style="width:100%;">
              <el-option v-for="rsl in levelList"
                :key="rsl.id"
                :label="rsl.name"
                :value="rsl.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属单位:">
            <el-select v-model="editData.unitId" :disabled="true" @change="orgOnchange" placeholder="请选择所属单位" width="100%" style="width:100%;">
              <el-option v-for="org in orgList" :label="org.name" :value="org.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目:">
            <el-select v-model="editData.projectId" :disabled="true" placeholder="请选择所属项目" width="100%" style="width:100%;">
              <el-option v-for="pjt in pjtList" :label="pjt.projectName" :value="pjt.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属施工队:">
            <el-select v-model="editData.teamId" :disabled="true" placeholder="请选择所属施工队" width="100%" style="width:100%;">
              <el-option v-for="tea in teamList" :label="tea.teamName" :value="tea.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属班组:">
            <el-select v-model="editData.groupId" :disabled="true" placeholder="请选择所属班组" width="100%" style="width:100%;">
              <el-option v-for="grp in groupList" :label="grp.groupName" :value="grp.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="列入事由:" prop="reason">
            <el-input type="textarea" :disabled="true" placeholder="请输入列入事由" v-model="editData.reason"></el-input>
          </el-form-item>
          <el-form-item label="有效时间:" prop="createTime">
            <el-input type="textarea" :disabled="true" placeholder="请输入列入事由" v-model="editData.dateRange"></el-input>
          </el-form-item>
          <el-form-item label="不良记录登记原因（详细情况说明）:" label-width="280px" prop="reasonDetail">
          </el-form-item>
          <el-form-item label="" prop="reasonDetail">
            <el-input type="textarea" placeholder="请输入不良记录登记原因" :disabled="true" v-model="editData.reasonDetail"></el-input>
          </el-form-item>
          <el-form-item label="附件上传:">
          </el-form-item>
          <!-- :on-preview="imgPreview" -->
          <el-form-item label="">
            <el-upload class="upload-demo" action="" :disabled="true" multiple :auto-upload="false" accept=""
            :file-list="editData.fileList"
            :on-preview="impPreview"
            list-type="picture">
            </el-upload>
          </el-form-item>
        </el-form>

      <el-dialog title="图片预览" v-model="showImgDialog" width="95%">
        <div style="">
            <img :src="imgUrl" style="width:100%;"/>
        </div>
    </el-dialog>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import {ElMessage} from 'element-plus';
import { listByCondition} from '@/api/heimingdan/heimingdan';
import { getItemByTypeCode} from '@/api/sys/item';

export default defineComponent({
    props:{
        editData:Object,
    },
    data(){
        return{
            teamList:[],
            pjtList:[],
            orgList:[],
            groupList:[],
            levelList:[],
            showImgDialog:false,
            imgUrl:null,
        }
    },
    mounted(){
        this.getLevelList();
        this.queryByUserId();
    },
    beforeUnmount(){

    },
    methods:{
        getLevelList(){
            getItemByTypeCode("blackList").then(({data}) => {//console.log('getLevelList',data);
                this.levelList = data.data;
            })
        },
        queryByUserId(){
            let param={userId:this.editData.userId};
            listByCondition(param).then(rep=>{
                console.log('listByCondition',rep);
                if(rep&&rep.data&&rep.data.data){
                    this.orgList=rep.data.data.orgList;
                    this.pjtList=rep.data.data.prjList;
                    this.teamList=rep.data.data.teamList;
                    this.groupList=rep.data.data.groupList;
                }
            });
        },
        impPreview(file) {console.log('impPreview',file);
          if(file&&file.url){
            this.imgUrl=file.url;
            this.showImgDialog=true;
          }
        },
    }
})
</script>
<style lang="scss" scoped>
</style>